"use client";

import Image from "next/image";
import { useState } from "react";
import Slider from "react-slick";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

import { ArrowRightIcon } from '@heroicons/react/20/solid'

import dynamic from 'next/dynamic';
const DynamicImage = dynamic(() => import('next/image'));
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from "next/link";
// import { CarouselReso } from 'react-responsive-carousel';

const incentives = [
  {
    name: 'Solutions',
    imageSrc: '/images/home/carousel/solution-info-graphic.png',
    description: "MF Asia Solution",
    href: "#order-management"
  },
  {
    name: 'Products',
    imageSrc: '/images/home/carousel/products-info-graphic.png',
    description: "MF Asia Products",
    href: "/catalog"
  }
]

const images = [
                {id: 1, src: '/images/home/carousel/Construction.jpg'},
                {id: 6, src: '/images/home/carousel/hospital.jpg'},
                {id: 2, src: '/images/home/carousel/cleanroom-1.webp'}, 
                {id: 3, src: '/images/home/carousel/cleanroom-2.jpg'},
                {id: 4, src: '/images/home/carousel/automotive-1.jpg'},
                {id: 5, src: '/images/home/carousel/food-processing.jpg'},
                {id: 8, src: '/images/home/carousel/labcoat.jpg'},
                {id: 7, src: '/images/home/carousel/lab.jpg'},
]

const SlickArrowLeft = ({ currentSlide, slideCount, ...props } : {
  currentSlide?: string,
  slideCount?: number
}) => (
  <ChevronLeftIcon {...props}
    style={{ left: 3, fontSize: "16px", background: "white", color: "#2563EB", padding: "5px", width: "40px", height: "40px" }}
    className={
      "slick-arrow slick-prev rounded-full ml-1 z-10 text-blue-600"
    }>
  </ChevronLeftIcon>
);

const SlickArrowRight = ({ currentSlide, slideCount, ...props } : {
  currentSlide?: string,
  slideCount?: number
}) => (
  <ChevronRightIcon {...props}
  style={{ right: 3, fontSize: "16px", background: "white", color: "#2563EB", padding: "5px", width: "40px", height: "40px" }}
    className={
      "slick-arrow slick-next rounded-full mr-1 z-10 text-blue-600"
    }>
  </ChevronRightIcon>
);

export default function Carousel() {

  const settings = {
    className: "center slider variable-width",
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // initialSlide: 0,
    speed: 500,
    dots: true,
    // lazyLoad: true,
    nextArrow: <SlickArrowRight/>,
    prevArrow: <SlickArrowLeft/>,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
    
    appendDots: dots => (
      <div
        style={{
          position: "relative",
          bottom: "0"
        }}
      >
        <ul> {dots} </ul>
      </div>
    ),
    // customPaging: i => (
    //   <div
    //     style={{
    //       width: "30px",
    //       border: "1px blue solid"
    //     }}
    //   >
    //   </div>
    // )
  };

  const newLocal = "mt-2 text-sm text-gray-500";
  return (
    <div className="relative py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl lg:text-center">
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            The most advanced uniform supply, laundry, rental and RFID linen management tools, all at your fingertips.
          </p>
        </div>
      </div>
      <div className="text-center mx-auto mt-20 grid max-w-sm grid-cols-1 gap-y-10 gap-x-8 sm:max-w-lg sm:grid-cols-2">
        {incentives.map((incentive) => (
          <Link key={incentive.name} className="text-center mx-auto sm:flex lg:block font-semibold"
            href={incentive.href}>
            <div className="sm:flex-shrink-0 z-10">
              <div className="flow-root z-10 mb-1">
                <Image className="relative mx-auto h-28 w-auto z-10" src={incentive.imageSrc} width={160} height="120" alt={incentive.description} />
              </div>
              <p
                className="w-100 rounded-full bg-gray-100 text-blue-600 px-7 py-2.5 text-lg font-semibold shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
              >
                {incentive.name}

                <ArrowRightIcon className=" inline mb-1 h-6 w-6 text-black ml-3"/>
              </p>
            </div>
          </Link>
        ))}
      </div>
      <div className="mx-auto mt-16">
        <Slider {...settings}>
          { images.map((image, index) => {
              return (
                <div style={{ width: 400 }} key={image.id}>
                  <DynamicImage
                    src={image.src}
                    alt="MF"
                    width={400}
                    height={400}
                    className="rounded-lg bg-gray-100 animate-fadeIn"
                  />
                </div>
              );
            })}
        </Slider>
      </div>
    </div>

  );
}